module.exports = __webpack_public_path__ + "img/ch07_12_哼小曲.e6755429.jpg";